// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// The dashboard's ordering, applied client-side. The grid and the map rail render the same
// complete set and must order it identically, so the rule lives here rather than in either.
// Client-side because the set is complete: every project matching the search and filter is
// already loaded, so re-ordering is a comparison, not a request.
//
// It is the ordering searchProject applies when it serves the grid a page at a time: the sort
// field; while searching, foldered matches ahead of unassigned ones (AUT-6376); and _id last so
// the order is total - projects tied on the field come out the same way every time.
// The fields the ordering reads - the complete set's entries and a folder page's raw projects
// both carry them.
export interface ISortableProject {
  _id: string;
  name?: string;
  updatedAt?: string;
  folderId?: string | null;
}

const hasFolder = (project: ISortableProject): number => (project.folderId ? 1 : 0);

const compareByField = (a: ISortableProject, b: ISortableProject, sortFilter: string): number => {
  if (sortFilter === 'nameA') return (a.name || '').localeCompare(b.name || '');
  if (sortFilter === 'nameD') return (b.name || '').localeCompare(a.name || '');
  return (b.updatedAt || '').localeCompare(a.updatedAt || '');
};

export const sortProjects = <T extends ISortableProject>(projects: T[], sortFilter: string, keyword: string): T[] => (
  [...projects].sort((a, b) => (
    (keyword ? hasFolder(b) - hasFolder(a) : 0)
    || compareByField(a, b, sortFilter)
    || b._id.localeCompare(a._id)
  ))
);

export default sortProjects;
